// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/chevron-right.js';

import { paths } from '../generated/chevron-right';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('chevron-right', Original, paths);
